import './index.scss'
import { Controller as BaseController } from 'stimulus'

export class Controller extends BaseController {
  static targets = ['text'];

  static values = {
    full: String,
    truncated: String
  };

  expanded = false;

  toggle() {
    this.expanded = !this.expanded
    this.textTarget.innerHTML = this.expanded ? this.fullValue : this.truncatedValue
  }
}
